import { connect } from 'react-redux'
import withFormFields from 'shared/ui/Form/withFormFields'
import { selectAccountIsOnboardingCompleted } from 'selectors/app'
import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import { doSaveAndRedirect } from './actions'

import VerificationPageView from './view'

const validators = {
  confirmationToken: value => {
    return /^[0-9]{6}$/.test(value) ? null : 'Invalid code'
  },
}

const initialValues = {
  confirmationToken: '',
}

const select = state => {
  const user = selectCurrentUser(state)
  return {
    initialValues,
    validators,
    email: user.unconfirmedEmail || user.email,
    isOnboardingComplete: selectAccountIsOnboardingCompleted(state),
  }
}

const perform = {
  onSave: doSaveAndRedirect,
}

export default connect(select, perform)(withFormFields(VerificationPageView))
